module.exports = __webpack_public_path__ + "static/media/400096_01.faff1594.png";